import React from "react";
import Content from "./components/content";

const KPI = () => {
  return (
    <>
      <Content />
    </>
  );
};

export default KPI;
